export const COMPANY = {
  name: "EMT-Reinigung",
  owner: "Resit Tokul",
  street: "Bahnhofstraße 19",
  city: "31275 Lehrte",
  phoneDisplay: "01573 1535266",
  phoneIntl: "+49 1573 1535266",
  phoneHref: "tel:+4915731535266",
  email: "emtreinigung@gmail.com",
};

const WA_MESSAGE =
  "Guten Tag, ich interessiere mich für eine professionelle Reinigung unseres Objekts und möchte gerne eine unverbindliche Anfrage stellen.";

export const WHATSAPP_URL = `https://wa.me/4915731535266?text=${encodeURIComponent(WA_MESSAGE)}`;

export const MAPS_URL = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
  "EMT-Reinigung, Bahnhofstraße 19, 31275 Lehrte"
)}`;

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -76 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export const NAV_LINKS = [
  { label: "Startseite", id: "start" },
  { label: "Leistungen", id: "leistungen" },
  { label: "Für Unternehmen", id: "unternehmen" },
  { label: "Über uns", id: "ueber-uns" },
  { label: "Einsatzgebiet", id: "einsatzgebiet" },
  { label: "Kontakt", id: "kontakt" },
];

export const SERVICES = [
  "Büro- & Unterhaltsreinigung",
  "Glas- & Fensterreinigung",
  "Treppenhausreinigung",
  "Grundreinigung",
  "Baureinigung",
  "Fassadenreinigung",
  "Hausmeisterservice",
  "Außenanlagenpflege",
];
